/**
 * PartAndAccessories Functional Component
 * @Package - seo/makeModel
 * @Author - Cybage@UPWA-Team
 * @description: PartAndAccessories related to makeModel SEO
 */
/**
 *  MakeModel SEO's PartAndAccessories Component
 */
import React, { useCallback, useMemo } from 'react'
import PageTypeIdentifier from '../../../helpers/PageTypeIdentifier'
import SeoPartAndAccessories from '../SeoPartAndAccessories'

export default function PartAndAccessories({
  dynamicApiData,
}) {
  const parts = useMemo(
    () => (dynamicApiData && dynamicApiData.topParts) || [],
    [dynamicApiData],
  )
  const hasParts = useMemo(() => Boolean(parts && parts.length), [parts])

  const heading = useMemo(
    () => (dynamicApiData && dynamicApiData.headings && dynamicApiData.headings.topParts) || '',
    [dynamicApiData],
  )

  const onItemClick = useCallback(() => PageTypeIdentifier.mmp(), [])

  if (!hasParts) {
    return null
  }

  return (
    <SeoPartAndAccessories
      id="MakeModelPartAndAccessories"
      records={parts}
      title={heading}
      onItemClick={onItemClick}
    />
  )
}
